export default "__VITE_ASSET__ef6acfac__"